const RESOURCE_NAME = "entities/candidateTeacherEvaluations";

export default {};
